/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const StagingAction = {
    Create: 'Create',
    Update: 'Update',
    Skip: 'Skip',
    Conflict: 'Conflict',
    Failed: 'Failed'
} as const;
export type StagingAction = typeof StagingAction[keyof typeof StagingAction];


export function instanceOfStagingAction(value: any): boolean {
    for (const key in StagingAction) {
        if (Object.prototype.hasOwnProperty.call(StagingAction, key)) {
            if (StagingAction[key as keyof typeof StagingAction] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StagingActionFromJSON(json: any): StagingAction {
    return StagingActionFromJSONTyped(json, false);
}

export function StagingActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): StagingAction {
    return json as StagingAction;
}

export function StagingActionToJSON(value?: StagingAction | null): any {
    return value as any;
}

export function StagingActionToJSONTyped(value: any, ignoreDiscriminator: boolean): StagingAction {
    return value as StagingAction;
}

